import { Cell, Content, Divider, Flex, Text, View } from '@adobe/react-spectrum';
import { getGrades } from '../../../data/ScoreDisplayUtils';
import { SORT_MAP } from '../../../data/redux/slices/leaderboardSlice';
import store from '../../../data/redux/store/AppStore';
import React from 'react';
import './ResultsCellRenderers.css';
import { AvatarImage } from '../../avatarImage/AvatarImage';
// import { Card, CardBody, CardPreview } from '@adobe/react-spectrum';

export const resultsCellRenderers = {
    CARD_LIST: (item, columnKey, clickCallBack) => {
        if (!store || !store?.getState()) {
            return <div />;
        }

        switch (columnKey) {
            case 'names':
            case 'name':
                let i = -1;

                const handleClick = (index) => {
                    clickCallBack && clickCallBack(item?.imageUris?.[index] || null);
                };

                return (
                    <div>
                        <Content>
                            <Flex direction={'column'}>
                                {item?.names &&
                                    item.names.map((name) => {
                                        const index = ++i;

                                        return (
                                            <span
                                                onClick={() => handleClick(index)}
                                                className={
                                                    item?.imageUris
                                                        ? 'commanderTiersTileStatisticsGridCellContentLeftClickable'
                                                        : 'commanderTiersTileStatisticsGridCellContentLeft'
                                                }
                                            >
                                                {name}
                                            </span>
                                        );
                                    })}
                            </Flex>
                        </Content>
                    </div>
                );
            default:
                return (
                    <div>
                        <div className={'commanderTiersTileStatisticsGridCellContentLeft'}>{item[columnKey]}</div>
                    </div>
                );
        }
    },
    UPGRADES: (item, columnKey) => {
        if (!store || !store?.getState()) {
            return <div />;
        }

        switch (columnKey) {
            case 'name':
                return (
                    <div>
                        <Content height={450}>
                            <Flex
                                direction={'column'}
                                justifyContent={'center'}
                                justifySelf={'center'}
                                alignItems={'center'}
                                maxWidth={500}
                                margin={30}
                                height={450}
                            >
                                <span className={'nameAndScoreLabel'} style={{ textAlign: 'center' }}>
                                    {item.name?.toUpperCase()}
                                </span>
                                <img src={item.imageUri} width={300} />
                                <span className={'nameAndScoreLabel'} style={{ textAlign: 'center' }}>
                                    SCORE: {item.score}
                                </span>
                            </Flex>
                        </Content>
                    </div>
                );
            default:
                return (
                    <div>
                        <div className="TextCell">{item[columnKey]}</div>
                    </div>
                );
        }
    },
    LEADERBOARD: (item, columnKey, options = {}) => {
        if (!store || !store?.getState()) {
            return <div />;
        }

        const compact = Boolean(options?.compact);
        const rowHeight = compact ? 78 : 90;
        const avatarSize = compact ? 50 : 50;

        let __subscriberTier = parseInt(item?.perks?.tier) ? `L${item?.perks?.tier}` : 'MAX';

        const sortBy = store.getState()?.[item?.storeKey]?.sortBy || store.getState()?.leaderboard?.sortBy;

        switch (columnKey) {
            case 'authorAvatarUrl':
                const avatarUrl = item?.author?.profileImageUrl || `/resources/blank-user-avatar.png`;
                const colors = item?.colorIdentity?.match(/./g) || [];

                return (
                    <div>
                        <Content marginTop={compact ? 6 : 7} marginBottom={compact ? 2 : 7}>
                            <Flex
                                direction={'column'}
                                // height={90}
                                justifyContent={'center'}
                                alignItems={'center'}
                                alignContent={'center'}
                                marginTop={0}
                            >
                                <div className="cellAvatar">
                                    {item?.perks?.avatarUri && item?.perks?.avatarUri !== '' ? (
                                        <AvatarImage size={avatarSize} avatarUrl={item.perks.avatarUri} />
                                    ) : (
                                        <img
                                            src={avatarUrl}
                                            width={`${avatarSize}px`}
                                            height={`${avatarSize}px`}
                                            alt={item.author?.username}
                                            style={{ objectFit: 'cover', borderRadius: 2 }}
                                        />
                                    )}
                                </div>
                                {!compact && (
                                    <div className="cellAvatarManaSymbols">
                                        {colors && colors.length > 0 && (
                                            <div>
                                                {colors?.map((symbol) => {
                                                    return (
                                                        <span
                                                            key={`${item?.id}__color${symbol?.toLowerCase()}`}
                                                            className={`mana xs s${symbol?.toLowerCase()}`}
                                                            style={{ opacity: '1' }}
                                                        ></span>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {item?.hasOwnProperty('perks') &&
                                    item.perks.showSubscriberLevelOnDeckRows &&
                                    item.perks.tier !== 'none' && (
                                        <Flex
                                            direction={'column'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            alignContent={'center'}
                                        >
                                            <span className={'subscriberLevelLabel'} style={{ fontSize: '.8rem' }}>
                                                {__subscriberTier}
                                            </span>
                                            <span className={'subscriberLevelLabel'}>SUPPORTER</span>
                                        </Flex>
                                    )}
                            </Flex>
                        </Content>
                    </div>
                );
                break;
            case 'saltRating':
                const score = item?.displayValue || 0;
                const grade = getGrades(item);
                const prop = sortBy?.enum.toLowerCase();
                let floatValue = parseFloat(/[0-9]*\.[0-9]/.exec(score.toString())?.[0] || `${score}`);
                if (!floatValue.toString().includes(`.`)) {
                    floatValue = `${floatValue}.0`;
                }

                return (
                    <span>
                        <Flex
                            direction={'column'}
                            height={'100%'}
                            justifyContent={'space-around'}
                            alignItems={'center'}
                        >
                            <span data-role={'large'} style={{ color: grade?.[prop]?.color }}>
                                {floatValue}
                            </span>
                        </Flex>
                    </span>
                );
                break;
            case 'commanders':
                let commanderList = item?.commanders;
                if (!Array.isArray(commanderList)) {
                    commanderList = [item?.commanders];
                }
                let commanders = ``;
                commanderList.forEach((commander) => {
                    if (commanders === ``) {
                        commanders = commander;
                    } else {
                        commanders = `${commanders}\n${commander}`;
                    }
                });

                const authorName = item?.author?.username;

                return (
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <Content height={rowHeight}>
                            <Flex
                                direction={'column'}
                                height={rowHeight}
                                minWidth={0}
                                justifyContent={'start'}
                                UNSAFE_style={compact ? { paddingTop: 8, paddingBottom: 10 } : undefined}
                            >
                                <Text
                                    data-role={'small-header'}
                                    UNSAFE_className={compact ? 'deckTitleLineClampCompact' : 'deckTitleLineClamp'}
                                    UNSAFE_style={{ color: '#fcef95' }}
                                >
                                    {item?.title}
                                </Text>
                                <Divider
                                    size="S"
                                    width="100%"
                                    marginTop={compact ? 2 : 5}
                                    marginBottom={compact ? 2 : 5}
                                    UNSAFE_style={{ backgroundColor: '#252525' }}
                                />
                                <Text UNSAFE_className={compact ? 'deckTitleLineClampCompact' : undefined}>
                                    {commanders}
                                </Text>
                                {authorName && (
                                    <Text UNSAFE_className="resultsRowAuthor">by {authorName}</Text>
                                )}
                            </Flex>
                        </Content>
                    </div>
                );

                break;
            default:
                return (
                    <div>
                        <Content height={rowHeight}>
                            <Text>{item[columnKey]}</Text>
                        </Content>
                    </div>
                );
        }
    },
};
